import React from 'react';
import PropTypes from 'prop-types';

export default function RegisterButtons(){
  return (
    // <section id={section_id} className="about-section">
    <div className="about-section">
      <div className="registers-container">        
        <a href="https://spiredatasets.ee.iisc.ac.in/syspincorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SYSPIN Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/englishttscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_1.0 Dataset
        </a>

        <a href="https://spiredatasets.ee.iisc.ac.in/gujaratittscorpus" className="regist-down-btn-outline" target='_blank' rel='noreferrer '>
          Download SPICOR TTS_2.0 Dataset
        </a>
      </div>
<h5 className="h5-medium section-title title-navy-blue pb-2 about-title ">Round 1 Selected Teams</h5>
      <div className="registers-container">   
             
        <div className="winner_box">
          Somya.ai
        </div>

        <div className="winner_box">
          LTRC-SPL
        </div>

        <div className="winner_box">
          CDAC-SVNIT
        </div>

        <div className="winner_box">
          Immverse AI
        </div>
      </div>
    </div>
  )
}

RegisterButtons.propTypes = {
  section_id: PropTypes.string.isRequired
}
